import React from "react";

import FooterLogin from "../AcessarMI/FooterLogin";

import { ContainerForm, ContainerWrapperForm, Header } from "./styles";

type FormLoginTemplateProps = {
  children: React.ReactNode;
};

const FormLoginTemplate: React.FC<FormLoginTemplateProps> = ({ children }) => {
  return (
    <ContainerWrapperForm>
      <Header>
        <h2>Bem vindo(a)</h2>
      </Header>
      <ContainerForm>
        {children}
        <FooterLogin />
      </ContainerForm>
    </ContainerWrapperForm>
  );
};

export default FormLoginTemplate;
